export interface AdvantageItem {
  id: string;
  label: string;
  description: string;
  secondaryDescription?: string;
  isHighlighted?: boolean;
  highlightLabelOnly?: boolean;
}

export const sectionTitle = "Turning AI Pilots into Enterprise Advantage";

export const advantageItems: AdvantageItem[] = [
  {
    id: "market-reality",
    label: "MARKET REALITY",
    description:
      "AI has moved from experimentation to core capital expenditure. Non-adoption is now an existential risk as competitors automate decision cycles and reset cost structures",
  },
  {
    id: "why-pilots-stall",
    label: "WHY PILOTS STALL",
    description:
      "Even with significant financial investments, companies are seeing only modest results—not due to weak models, but because structural obstacles prevent them from scaling",
  },
  {
    id: "margin-pressure",
    label: "MARGIN PRESSURE",
    description:
      "Companies spend money developing AI prototypes but cannot scale them effectively, preventing cost savings and revenue losses",
  },
  {
    id: "ontology-edge",
    label: "THE ONTOLOGY EDGE",
    description:
      "Ontology provides the adaptive fabric that enables AI to reason and act across systems, transforming isolated pilots into enterprise-wide impact",
    isHighlighted: true,
  },
];
